import { useRef } from 'react';
import { QueryClientProvider } from 'react-query';

import { AuthProvider } from '~/lib/auth';
import { ApiClient } from './ApiClient';
import { ApiContext } from './ApiContext';

/**
 * The main configuration to instantiate the `ApiProvider`.
 */
export type IApiProviderOptions = {
  /**
   * The child nodes your Provider has wrapped.
   */
  children?: React.ReactNode;

  /**
   * Context to be used when creating the ApiProvider, defaults to the
   * internally created context.
   */
  context?: React.Context<ApiClient>;

  clientId: string;
};

/**
 * Provides the ApiContext to its child components.
 */
export const ApiProvider: React.FC<IApiProviderOptions> = (props) => {
  const { children, context = ApiContext, clientId } = props;
  const { current: client } = useRef(new ApiClient(clientId));

  return (
    <QueryClientProvider client={client.queryClient}>
      <AuthProvider
        clientId={clientId}
        cacheLocation="local"
        apiClient={client}
      >
        <context.Provider value={client}>{children}</context.Provider>
      </AuthProvider>
    </QueryClientProvider>
  );
};
